import React from 'react'
import { connect } from 'react-redux'
import { Header, Label, Card, Statistic, Button, Input, Form, Modal, Icon } from 'semantic-ui-react'
import InputMask from 'react-input-mask'
import {Link} from 'react-router-dom'
import { MAIN_COLOR, ACCENT_COLOR, plansCost } from 'globals/consts'
import { formatCurrency } from 'globals/utils'
import { logout } from 'data/auth/action'
import { getSubscription } from 'data/subscription/action'
import { activatePlan } from 'data/auth/action'
import Loaded from 'components/loaded'
import api from 'api'
import { withRouter, isEmpty} from 'globals/utils' 
import { selectPlan } from 'data/advisor/plan/action'
import { loadStripe } from '@stripe/stripe-js'
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js'

const stripePromise = null

class UserSubscription extends React.Component {
  constructor(props) {
    super(props)

    this.stripePromise = loadStripe(`${process.env.REACT_APP_STRIPE_PUBLIC}`, {})

    this.state = {
      loading: false,
      deleteAccountModal: false,
      cancelSubModal: false,
      unlinkAccountModal: false,
      selectPlan: false,
      discount: 0,
      discountCode: '',
      discountCodeLoading: false,
      activateLoading: false,
      discountValidationSuccess: false,
      advisorLink: false,
      advisorLoading: false,
      stripeOpen: false,
      subExists: false,
      clientSecret: null,
      errors:{}
    };
    if(props.saveRef){
      props.saveRef(this)
    }
  }

  componentDidMount() {
    this.setState({ loading: true })
    this.props.getSubscription().then(()=>{
      this.setState({ loading: false })
    }).catch(err=>{
      console.log('error loading Subscription:', err)
      this.setState({ loading: false })
    })
  }  

  componentDidUpdate(prevProps) {
    if( prevProps.subscription !== this.props.subscription ){ 
      if (this.props.subscription.type === '' || this.props.subscription.type === 'SIGNUP') {
        this.setState({selectPlan: true})
      }
    }
  }
  onChangePlanClick = () => {
    this.setState({
      selectPlan: true
    })
  }

  onBack = () => {
    this.setState({
      selectPlan: false,
      discount: 0,
      discountCode: '',
      discountCodeLoading: false,
      discountValidationSuccess: false,
      advisorLoading: false,
      stripeOpen: false,
      errors:{}
    })
  }
  onCloseStripe = () => {
    this.setState({
      stripeOpen: false,
      errors:{}
    })
  }
  onDeleteAccountClick = () => {
    this.setState({ deleteAccountModal: true })
  }
  onUnsubscribeClick = () => {
    this.setState({ cancelSubModal: true })
  }
  onUnLinkClick = () => {
    this.setState({ unlinkAccountModal: true })
  }
  
  onManagePlanClick = () => {
    //Post to Server Get stripe session code
    api.stripe.getBillingPortal(sessionStorage.getItem('token')).then((session)=>{
      if (!!session && !!session.url) {        
        window.location.replace(session.url)
      }
    }).catch(err=>{
      console.log('error loading Subscription:', err)
      this.setState({ loading: false })
    })
  }
  onNewPlanSelect = (selectedPlan) => {
    //Post to Server Get stripe session code
    if (selectedPlan==='TRIAL') {
      this.activatePlan(selectedPlan)
    } else {
      api.stripe.getCheckout(selectedPlan).then((data)=>{
        if (data==='active') {
          this.setState({
            subExists: true
          })
        } else {
          this.setState({
            stripeOpen: true,
            clientSecret: data.clientSecret,
          })
        }
      }).catch(err=>{
        console.log('error loading Subscription:', err)
        this.setState({ loading: false })
      })
    }
  }

  onDiscountCodeChange = e => this.setState({discountCode: e.target.value, discountValidationSuccess: false, discount: 0, active: 'new_sub', errors: {}})

  handleDiscountValidation = () =>{
    const { discountValidationSuccess, discountCode } = this.state
    if(!discountValidationSuccess && discountCode.length > 0){
      this.setState({discountCodeLoading: true})
      api.account.validateDiscountCode(discountCode).then(res=>{
        this.activatePlan(discountCode)
      }).catch(err=>{
        console.log('err', err)
        this.setState({
          discountCodeLoading: false,
          discountValidationSuccess: false,
          errors: {discountCodeInvalid: (err.response && err.response.data && err.response.data.Message) ? err.response.data.Message : 'This Code is invalid'}
        })
      })
    }else if (discountCode.length === 0) {
      this.setState({
        discount: 0,
        discountCode: '',      
        discountCodeLoading: false,
        discountValidationSuccess: false,
        planPayPalCode: null,
        errors: {discountCodeInvalid: 'Enter a Promo Code'}
      })
    }
  }

  handleDeleteAccount = () => {
    this.setState({ deleteAccountModal: false })
    api.account.deleteAccount()
    this.props.logout().then(()=>this.props.navigate("/login"))
  }

  handleCancelSub = () => {
    this.setState({ cancelSubModal: false })
    api.account.cancelSubscription()
    this.props.switchTab(null, { name: 'unsubscribed' })
  }
  handleUnlinkAccount = () => {
    this.setState({ advisorLoading: true })
    api.system.unlinkAdvisor().then(()=>this.props.logout().then(()=>this.props.navigate("/login")))
  }

  onAdvisorCodeChange = e => this.setState({advisorCode: e.target.value, errors: {}})
  
  handleLinkAdvisor = () =>{
    const { advisorCode } = this.state
    if (!advisorCode || advisorCode.length === 0) {
      this.setState({ 
        advisorLink: false,
        advisorCode: '',       
        errors: {advisorCodeInvalid: 'Enter an Advisor Number'}
      })
    } else if (advisorCode.length < 12) {
      this.setState({
        advisorLink: false,
        advisorCode: '', 
        errors: {advisorCodeInvalid: 'This Number is invalid'}
      })
    } else {
      this.setState({advisorLoading: true})
      api.system.linkAdvisor(advisorCode).then(()=>this.props.logout().then(()=>this.props.navigate("/login")))
      .catch(err=>{ 
        this.setState({
          advisorLink: false,
          advisorLoading: false, 
          errors: {advisorCodeInvalid: !!err.response && !!err.response.data.Message ? err.response.data.Message : 'This Number is invalid'}
        })
      })
    }
  }
  
  activatePlan = (code) => {    
    this.setState({ activateLoading: true })
    this.props.activatePlan(code).then(res=>{      
      this.props.navigate("/loading")      
    }).catch(err=>{
      console.log('err', err)
      this.setState({
        activateLoading: false,        
        errors: {activateInvalid: (err.response && err.response.data && err.response.data.Message) ? err.response.data.Message : 'Plan Activation Failed'}
      })
    })
  }
  
  renderCards= () => {
    const { expired } = this.props
    let cards = []
    for (let c = !expired?0:1; c < 4; c++) {      
      cards.push(
      <Card className="selectNewPlan_card">
        <Card.Content className={`selectNewPlan_card_header selectNewPlan_card_header--${plansCost[c].hdrcolor}`} header={plansCost[c].desc} />
        <Card.Content className="selectNewPlan_card_description selectNewPlan_card_description--labled">
          <Statistic>
            <Statistic.Value>{plansCost[c].label}</Statistic.Value>
          </Statistic>
          <Label style={{width: plansCost[c].tagwidth}} color={plansCost[c].tagcolor} tag>{plansCost[c].tagline}</Label>
          <p>{ c===0 ? plansCost[c].desc :`Billed ${formatCurrency(plansCost[c].cost,2)} ${plansCost[c].billed}`}</p>
        </Card.Content>
        <Card.Content className="selectNewPlan_card_button" extra>
          <Button onClick={()=>this.onNewPlanSelect(plansCost[c].type)} fluid className={(c===0||c===2)?'':'basic'} color={plansCost[c].btncolor}>{plansCost[c].type==='TRIAL'?'Start Trial':'Select Plan'}</Button>
        </Card.Content>
      </Card>
      )
    }
    return cards
  } 

  render() {
    const {loading,
      selectPlan,
      errors,
      discount,
      discountCode,
      discountCodeLoading,
      discountValidationSuccess,
      activateLoading,
      advisorCode,
      advisorLink,
      advisorLoading,
      deleteAccountModal,
      cancelSubModal,
      stripeOpen,
      subExists,
      unlinkAccountModal } = this.state

    const { subscription, subHeader } = this.props
    if(isEmpty(subscription)) return <h4>Loading...</h4>
    console.log(subscription)
    return (
      <Loaded loading={loading}>
      <div>
        <Header style={{color: MAIN_COLOR}} as='h2'>
          { selectPlan ? 'Select New Plan' : 'Your Subscription' }
          <Header.Subheader>
            { subHeader }
          </Header.Subheader>
       </Header>
        
        { subscription.type.toLowerCase() !== 'client' &&
          <Header as='h5'>
            Link to Advisor
            <Form.Field inline>
              <Input style={{margin: '10px 10px 10px 0'}}  size='small'
                value={advisorCode} 
                error={!!errors.advisorCodeInvalid}> 
                <InputMask
                mask="999-999-9999" 
                maskChar={null}
                placeholder='Enter Advisor Number'
                onChange={this.onAdvisorCodeChange} />
              </Input>
              <Button color="green" onClick={()=>this.setState({ advisorLink: true })} loading={advisorLoading} disabled={advisorLoading} content='Link'/>
              {
                !!errors.advisorCodeInvalid && <Label basic color='red' pointing='left'>{errors.advisorCodeInvalid}</Label>
              }
            </Form.Field>
          </Header>
        } 
        
        {!selectPlan ?
          <React.Fragment>
            <Header as='h5'>
              Subscription:
              <Header.Subheader>
              {subscription.description}
              </Header.Subheader>
            </Header>
            { subscription.type.toLowerCase() === 'client' ? 
            <Header as='h5'>
              Subscription based on Advisors Status              
            </Header>
            :
            <Header as='h5'>
              { subscription.status.toLowerCase() === 'expires' ? 'Subscription Expires On':'Next Payment Date:'}
              <Header.Subheader>
              {subscription.nextBilling && new Date(subscription.nextBilling).toLocaleDateString("en-CA")}
              </Header.Subheader>
            </Header>
            }
            { subscription.type.toLowerCase() === 'client' ? 
              <Button onClick={this.onUnLinkClick} style={{ color:'white', background: ACCENT_COLOR }}>Un-Link From Advisor</Button>
              :
              <React.Fragment>
              {
                (subscription.status.toLowerCase() === 'expires' || ['expired', 'trial'].includes(subscription.type.toLowerCase())) ?
                  <Button onClick={this.onChangePlanClick} style={{ color:'white', background: ACCENT_COLOR }}>Select Plan</Button> 
                :
                subscription.id.startsWith('sub') ?
                <Button onClick={this.onManagePlanClick} style={{ color:'white', background: ACCENT_COLOR }}>Manage Subscription</Button> 
                :  
                <Button onClick={this.onUnsubscribeClick} style={{ color:'white', background: ACCENT_COLOR }}>Unsubscribe</Button> 
              }
              </React.Fragment>
            }
            <Button onClick={this.onDeleteAccountClick} floated='right' color='red'>Delete Account</Button>
          </React.Fragment>
          :
          <React.Fragment>
            <Header as='h5'>
            Enter your promotion code now if you have one to validate an offer or select the desired subscription.
            <Form.Field inline>
              <Button color={ !discountValidationSuccess ? "red" : "green"} onClick={this.handleDiscountValidation} loading={discountCodeLoading} disabled={discountCodeLoading} className='' content='Validate Code'/>
              <Input style={{margin: '10px 0 10px 10px'}}  size='small'
                value={discountCode} 
                error={!!errors.discountCodeInvalid}> 
                <InputMask
                mask="***-***-***-***" 
                maskChar={null}
                placeholder='Enter Promo Code'
                onChange={this.onDiscountCodeChange} />
              </Input>
              {
                !!errors.discountCodeInvalid && <Label basic color='red' pointing='left'>{errors.discountCodeInvalid}</Label>
              }
            </Form.Field>
            </Header>
            {
              !!errors.activateInvalid && <div><Label basic color='red'>{errors.activateInvalid}</Label><br/><br/></div>
            }
            <div className="selectNewPlan_cardContainer">
              { this.renderCards() }
            </div>
            {
              this.props.subscription.type !== 'SIGNUP' && <Button style={{marginTop: '20px'}} color='yellow' onClick={()=>this.onBack()}>Back</Button>
            }
          </React.Fragment>
        }

        { stripeOpen &&
          <Modal dimmer='blurring' open={stripeOpen} size='small'>
            <Modal.Content>
              <EmbeddedCheckoutProvider stripe={this.stripePromise} options={{clientSecret: this.state.clientSecret}}>
                <EmbeddedCheckout />
              </EmbeddedCheckoutProvider>
            </Modal.Content>
            <Modal.Actions>
              <Button style={{marginTop: '20px'}} color='yellow' onClick={()=>this.onCloseStripe()}>Back</Button>
            </Modal.Actions>
          </Modal>
        }
        
        <Modal dimmer='blurring' open={subExists} size='mini'>
          <Header color="orange" icon='linkify' content='Subscription Pending' />
          <Modal.Content>
            <p>Your subscription is still being activated.</p>
            <p>Please try logging in again.</p>
          </Modal.Content>
          <Modal.Actions>
            <Link className='ui green button' to='/login'>Login</Link>
          </Modal.Actions>
        </Modal>

        <Modal dimmer='blurring' open={advisorLink} size='small'>
          <Header color="orange" icon='linkify' content='Link to an Advisor' />
          <Modal.Content>
            <p>When you link to an advisor you agree to be contacted by and share you data with your chosen advisor.</p>
            <p>This will end your session and log you out of the software, please login again to continue.</p>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={()=>this.setState({ advisorLink: false })} color='red'>
              <Icon name='remove' /> No
            </Button>
            <Button onClick={this.handleLinkAdvisor} color='green' loading={advisorLoading} disabled={advisorLoading} >
              <Icon name='checkmark' /> Yes
            </Button>
          </Modal.Actions>
        </Modal>
        {
          this.props.subscription.type !== 'SIGNUP' &&
          <React.Fragment>
            <Modal dimmer='blurring' open={unlinkAccountModal} size='small'>
              <Header color="orange" icon='unlink' content='Unlink from Advisor' />
              <Modal.Content>
                <p>Are you sure you wish to remove your advisor, you will require a subscription to continue using the software.</p>
                <p>This will end your session and log you out of the software.</p>
              </Modal.Content>
              <Modal.Actions>
                <Button onClick={()=>this.setState({ unlinkAccountModal: false })} color='red'>
                  <Icon name='remove' /> No
                </Button>
                <Button onClick={this.handleUnlinkAccount} color='green' loading={advisorLoading} disabled={advisorLoading}>
                  <Icon name='checkmark' /> Yes
                </Button>
              </Modal.Actions>
            </Modal>

            <Modal dimmer='blurring' open={deleteAccountModal} size='small'>
              <Header color="orange" icon='trash' content='You are about to delete your account' />
              <Modal.Content>
                <p>Are you sure you want to delete your account?</p>
              </Modal.Content>
              <Modal.Actions>
                <Button onClick={()=>this.setState({ deleteAccountModal: false })} color='red'>
                  <Icon name='remove' /> No
                </Button>
                <Button onClick={this.handleDeleteAccount} color='green'>
                  <Icon name='checkmark' /> Yes
                </Button>
              </Modal.Actions>
            </Modal>

            <Modal dimmer='blurring' open={cancelSubModal} size='small'>
              <Header color='orange' icon='trash' content='You are about to cancel your subscription' />
              <Modal.Content>
                <p>Are you sure you want to cancel your subscription?</p>
              </Modal.Content>
              <Modal.Actions>
                <a href={'https://www.paypal.com/cgi-bin/webscr?cmd=_subscr-find&alias=' + process.env.REACT_APP_PAYPAL_UNSUBSCRIBE} className="ui green basic button"> 
                  Go To PayPal To Unsubscribe
                </a>
                <Button onClick={()=>this.setState({ cancelSubModal: false })} color='red'>
                  <Icon name='remove' /> Cancel
                </Button>
              </Modal.Actions>
            </Modal>
          </React.Fragment>
        }
      </div>
      </Loaded>
    )
  }
} 
UserSubscription.defaultProps = {
  subHeader: 'Making Better Money Choices is an on going process, not an event'
}
function mapStateToProps(state) {
  return {
    subscription: state.shared_data.subscription
  }
}

export default withRouter(connect(mapStateToProps, { activatePlan, getSubscription, logout})(UserSubscription))

